import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=4566255a&scoped=true&"
import script from "./Privacy.vue?vue&type=script&lang=js&"
export * from "./Privacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4566255a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4566255a')) {
      api.createRecord('4566255a', component.options)
    } else {
      api.reload('4566255a', component.options)
    }
    module.hot.accept("./Privacy.vue?vue&type=template&id=4566255a&scoped=true&", function () {
      api.rerender('4566255a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Setting/Privacy.vue"
export default component.exports